<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <!-- Pagina di login per il servizio -->
    <AmilonLoginPage :service_title="service_title" :service="service"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import AmilonLoginPage from '@/components/amilon/AmilonLoginPage'

export default {
  name: 'AmlHoepli',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Hoepli", link : 'conv-aml-hoepli' } ],

        // variabili che definiscono il servizio expedia con la quale
        // configuriamo la pagina di login.
        service_title: "Hoepli",
        service: 100
    }
  },
  components: {
    PageTagline,
    AmilonLoginPage
  }
}
</script>

<style scoped></style>